<template>
    <select-modal 
        :ref="id"
        :id="id"
        :placeholder-button="tituloBotao"

        :titleModal="tituloModal"
        :modal-fields="colunasModal" 
        :fetch-method="metodoBusca"
        :term-initial="termoFiltro"
        
        :fields="colunasMutaveis" 
        :values="dadosMutaveis"

        :slot-image="colunaImagem"
        :slot-tabela-image="colunaTbImagem"

        @update="update"
        :controles="controles"

        :hide-button="true"
        :hide-selected="esconderSelecionados"

        :accordionTitle="tituloTabelaMutavel"

        :esconderInserir="esconderInserir"
    >

        <template #before-table>
            <accordion
                :id="`${id}-1`" 
                :title="tituloTabelaImutavel"
                sub
                :accordion="id"
                visible
            >
               <div class="p-3">
                    <div class="table-responsive">
                        <b-table head-variant="dark" hover :items="dadosImutaveis" :fields="colunasImutaveis">
                            <template v-slot:[`cell(${colunaTbImagem})`]="data">
                                <b-avatar  :src="data.value"></b-avatar>
                            </template>
                        </b-table>
                    </div>
               </div>
            </accordion>
        </template>
        <template #btn-remove="data">
            <slot name="btn-remove" :data="data"></slot>
        </template>
        
    </select-modal>
</template>
<script>
import SelectModal from "@/components/modal/SelectModal";
import Accordion from '@/components/card/Accordion';

export default {
    name: "SelectModalPersonalizado",
    components: {
        SelectModal,
        Accordion
    },
    props : {
        id : {
            type: String,
            required: true
        },
        tituloBotao : {
            type: String,
            default: "Inserir"
        },
        colunasModal : {
            type: Array,
            default: () => [],
        },
        colunasMutaveis : {
            type: Array,
            default: () => [],
        },
        dadosMutaveis : {
            type: Array,
            default: () => []
        },
        metodoBusca : {
            type: Function,
            default: null,
        },
        termoFiltro : {
            type: String,
            default: ""
        },
        colunaImagem : {
            type: String,
            default: null
        },
        tituloModal : {
            type: String,
            default: ""
        },
        controles : {
            type: Boolean,
            default: false
        },
        tituloTabelaImutavel : {
            type: String,
            default: ""
        },
        tituloTabelaMutavel : {
            type: String,
            default: ""
        },
        colunasImutaveis : {
            type: Array,
            default: () => []
        },
        dadosImutaveis : {
            type: Array,
            default: () => []
        },
        esconderBotao : {
            type: Boolean,
            default: false
        },
        esconderSelecionados : {
            type: Boolean,
            default: false
        },
        colunaTbImagem : {
            type: String,
            default: null
        },

        esconderInserir : {
            type: Boolean,
            default: false
        }
    },
    methods: {
        update: function(value){
            this.$emit("update", value);
        },
        recarregar(){
            this.$refs[this.id].recarregar();
        }
    },
}
</script>
<style lang="">
    
</style>